import React from 'react';

const WhyChoose = () => {
  return (
    <section className="home-why-choose" style={{ backgroundImage: 'url(assets/img/home-why-choose-bg.png)' }}>
      <div className="container-lg inner-container text-white">
        <div className="row">
          <div className="col-lg-9">
            <h6>Why Choose</h6>
            <h3 className="why-chose">Why Choose Our <span className="c-F0B2FF">B2B Digital Marketing Services</span>.</h3>
            <h5 className="screw-vanity"><i>Screw vanity metrics. Cut through the noise with marketing that matters.</i></h5>
            <p className="desc-1">We know you’re not just looking for clicks and likes — you want real, measurable growth that impacts your bottom line. That’s why we say, “Screw vanity metrics.” Our focus is on finding leads, driving revenue, and delivering results
              that genuinely matter to your business.</p>
          </div>
        </div>
      </div>
      <div className="container-xl inner-container text-white">
        <div className="px-lg-4">
          <div className="row">
            <div className="col-lg-3">
              <div className="choose-lft">
                <div className="row">
                  <div className="col-lg-12 col-md-6">
                    <div className="choose-revenu-box blk">
                      <div className="icon-list choose-icnss revenue-driven">
                      </div>
                      <h5>Revenue-Driven Strategies: </h5>
                      <p>We focus on what truly counts — your bottom line. Our strategies are designed to turn leads into revenue, not just impressive stats.</p>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-6">
                    <div className="choose-revenu-box wit text-black mb-0">
                      <div className="icon-list choose-icnss human-centric">
                      </div>
                      <h5>Human-Centric Approach:</h5>
                      <p>At the heart of our marketing is P2P (People to People). We engage your prospects with empathy, emotion, and a touch of evangelism, creating meaningful relationships that drive success.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="ps-growth">
                <img src="assets/img/pps-growth.png" alt="" />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="choose-right">
                <div className="row">
                  <div className="col-lg-12 col-md-6">
                    <div className="choose-revenu-box trn">
                      <div className="icon-list choose-icnss network-beyond">
                      </div>
                      <h5>Network Beyond Marketing</h5>
                      <p>More than just marketing; we open doors to valuable connections. Gain access to our network of real buyers and key decision-makers. </p>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-6">
                    <div className="choose-revenu-box blk">
                      <div className="icon-list choose-icnss transparent-measurable">
                      </div>
                      <h5>Transparent and Measurable Results:</h5>
                      <p>With us, you'll see exactly where your investment is going. Our transparent reporting system keeps you in the loop every step of the way.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
